import { render, staticRenderFns } from "./UpdateApprovalMatrix.vue?vue&type=template&id=ea79f7de"
import script from "./UpdateApprovalMatrix.vue?vue&type=script&lang=js"
export * from "./UpdateApprovalMatrix.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports